import React, { useState, useEffect } from 'react';
import './Termin.css';
import Calendar from '../Calendar/Calendar';
import '../Home/Home.css';
import axios from 'axios';
import { DatePicker, Skeleton } from 'antd';
import moment from 'moment';
import { environment } from '../../environment';
import swal from 'sweetalert';
import { Alert, TextField } from '@mui/material';

const Termin = () => {
  const [termins, setTermins] = useState([]);
  const registerTerminNoAccUrl = `${environment.LOCALHOST_URL}/termin/register`;
  const [selectedDate, setSelectedDate] = useState();
  const getAllTerminsUrl = `${environment.LOCALHOST_URL}/termin/all-termins`;

  const hours = [...Array(24)].map((_, i) => 5 + i).filter(h => h <= 17);
  const minutes = [0, 30];
  const [emri, setemri] = useState('');
  const [tel, setTel] = useState('');
  const [value, onChange] = useState(null);
  
  const [time, setTime] = useState('');

var allTermins = [];
 termins.map((termin) => {
    allTermins.push(termin);
})

const handleChanges = e => {
  setTime(e.target.value);
};

useEffect(() => {
  axios
    .get(getAllTerminsUrl)
    .then((response) => {
      setTermins(response.data.allTermins);
      console.log(response.data.allTermins)
    })
    .catch((error) => {
      console.log(error);
    });
}, [getAllTerminsUrl]);


  const handleReservation = async () => {
    const formattedDate = moment(selectedDate).format('DD-MM-YYYY');
    await axios(registerTerminNoAccUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        client: emri,
        clientTel: tel,
        terminHour: time,
        terminDate: formattedDate
      }),
    })
      .then(
        swal({
              title: `Termini u dergua me sukses`,
              buttons: {
                cancel: 'Mbyll',
              },
            })
      ).then(
        window.location.href = "/"
      )

  };


  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate());
    return result;
  }

  const handleChange = (e) => {
    setTime(e.target.value);
    console.log({ time: e.target.value });
  };

  const writeNumber = (e) => {
    const tel = e.target.value;
    if (tel.startsWith('+')) {
      setTel(tel);
    } else {
      swal({
        title: 'Ju lutemi shkruani nje numer telefoni valid (duket filluar me +)',
        buttons: {
          cancel: 'Mbyll',
        },
      });
    }
  }
  

  return (
    <>
      <Alert style={{textAlign:'center'}} severity="info">Mbush të dhënat e nevojshme për te rezervuar terminin tuaj!</Alert>
    <div className="main-termin container">

      <TextField
       id="standard-basic"
       label="Emri dhe mbiemri"
       variant="standard"
       style={{width:'50%', display:'flex', margin:'0 auto'}}
       onChange={(e) => setemri(e.target.value)}
       />
      
      <TextField
       id="standard-basic"
       label="Tel"
       variant="standard"
       style={{width:'50%', display:'flex', margin:'0 auto'}}
       onChange={writeNumber}
       />
      



        <br/>
        <br/>
        <label>Selekto daten*</label>
        <br/>
      <DatePicker
        style={{width:'50%', height:'60px'}}
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date.toDate())}
        minDate={new Date()}
        maxDate={addDays(selectedDate, 0)}
        showYearDropdown
        dateFormat="MMMM d, yyyy"
        scrollableYearDropdown
        />




{/* <div className="time-picker">
    <input
    type="time"
    value={time}
    onChange={e => handleChange(e.target.value.slice(0, -3))}
    step="1800"
    min="00:00"
    max="23:30"
    />
  </div> */}

<div className="time-picker" style={{width:'50%', height:'60px'}}>
    <select value={time} onChange={handleChanges}  className='form-control' disabled={!selectedDate}>
      {hours.map(hour =>
        minutes.map(minute => (
          <option
          key={`${hour}:${minute}`}
          value={`${hour}:${minute < 10 ? "0" + minute : minute}`}
          >
            {hour}:
            {minute < 10 ? "0" + minute : minute}
          </option>
        ))
        )}
    </select>
  </div>

  {selectedDate && time &&
      <h1 className="date-time">
        Data e terminit : {moment(selectedDate).format('DD/MM/yyyy')  } / Ora : { time }
      </h1>
}


      <button 
        onClick={handleReservation}
        className="btn btn-warning"
        >
        Rezervo
      </button>
    </div>
         </>
  );
};
export default Termin;
